import React from 'react';
import AuthService from "../../../../services/auth-service/AuthService";
import NotificationService from "../../../../services/notification-service/NotificationService";

function DownloadReportButton({appointmentId}) {
    const downloadFile = async () => {
        try {
            const token = AuthService.getAuthToken();
            const response = await fetch(`${process.env.REACT_APP_AUDIT_REPORT_API_URL}/api/v1/audit/audit-report/${appointmentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (!response.ok) {
                NotificationService.showNotification({
                    severity: 'error',
                    summary: 'Report Error',
                    detail: 'Unable to download audit report. The response code was ' + response.status
                });

                return;
            }

            // Get the filename from the content disposition header if it exists (optional)
            const disposition = response.headers.get('content-disposition');
            const matches = disposition && disposition.match(/filename="(.+)"/);
            const filename = matches && matches[1] ? matches[1] : `audit-report-for-appointment-${appointmentId}.pdf`;

            // Get the file as a Blob
            const blob = await response.blob();

            // Create a download link
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            link.click();

            // Clean up the URL object
            window.URL.revokeObjectURL(url);
        } catch (error) {
            NotificationService.showNotification({
                severity: 'error',
                summary: 'Report Error',
                detail: 'Unable to download audit report:' + error.message
            });
        }
    };

    return (
        <button onClick={downloadFile}>
            Audit Report
        </button>
    );
}

export default DownloadReportButton;